import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../components/customButton";
import useOrderDetail from "../../store/order/detailOrders";
import { useEffect, useState } from "react";
// import useDeliveryStore from "../../store/order/passerCommande";
import axios from "axios";
import { orders, userDetail } from "../../lib/apis";
import { toast, ToastContainer } from "react-toastify";
import Breadcrumb from "../../components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { FaArrowLeft } from "react-icons/fa";
import { formatNombre, scrollToTop } from "../../lib/utils";

interface User {
  name: string;
  city: string;
  phone_number: string
}

const Details = () => {
  const Id = useParams().id;
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const { t, i18n } = useTranslation()
  const token = localStorage.getItem("token")
  const [producteur, setProducteur] = useState<User>()
  const userID = localStorage.getItem("user")

  const { orderDetail, fetchOrderDetail, loadingDetail } = useOrderDetail();

  useEffect(() => {
    scrollToTop()
  }, [])

  useEffect(() => {
    if (Id) {
      fetchOrderDetail(Id);
    }
  }, [fetchOrderDetail, Id]);
  const updateProducteur = async () => {
    console.log("orderDetail", orderDetail)
    try {
      if (orderDetail) {
        const { data } = await axios.get(`${userDetail}/${orderDetail[0].products[0].producer_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }

        )
        setProducteur(data.user)
      }

    } catch (error: any) {
      console.error("Error fetching producteur:", error);
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(i18n.language === "fr" ? error.response.data.message : error.response.data.messageE)
      }


    } finally {

    }
  }
  useEffect(() => {
    updateProducteur()
    // eslint-disable-next-line
  }, [orderDetail])


  const commandeRecupere = async (id: string) => {
    setLoader(true)
    try {
      await axios.put(`${orders}/${id}/client/${userID}/receive`, {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      if (Id) fetchOrderDetail(Id)
      toast.success(t("success_commande_recuperer"))
    } catch (error: any) {
      toast.error(i18n.language === "fr" ? error.response.data.message : error.response.data.messageE)
    } finally {
      setLoader(false)
    }
  }


  return (
    <div className="px-8 flex flex-col gap-6 pt-4">
      <div className="flex flex-row mt-6  items-center justify-start w-full">

        <Breadcrumb />
      </div>
      <div className=" flex justify-between ">
        <h2 className="text-[27px] font-normal">{t("detail_commande")}</h2>
        {/* <h2 className="text-[27px] font-normal bg-yellow-600">{orderDetail[0].status}</h2> */}
      </div>


      {loadingDetail ? (
        <p>Loading...</p>
      ) : (
        orderDetail?.map((order: any) => (
          <div
            key={order.order_id}
            className="border-grey border-[2px] py-5 rounded-[5px] "
          >
            <div className="bg-softGrey rounded-[5px] py-3 px-5">
              <ul className="w-full flex justify-between">
                <li>
                  {t("commande_at")} <br />
                  {new Date(order.created_at).toLocaleDateString()}{" "}
                  {/* Format the date */}
                </li>

                <li>
                  <span>{t("num_commande")}</span> <br />
                  <span className="text-primary text-sm font-normal">
                    Order #{order.order_id}
                  </span>
                </li>
                {/* <CustomButton className="bg-secondary px-8 py-2">
                  <span className="text-white">Facture</span>
                </CustomButton> */}
              </ul>
            </div>

            <div className="py-3 px-5 flex justify-between flex-wrap gap-y-5">
              {order.products.length > 0 && <div className="min-w-[310px] text-sm">
                <h4 className="font-normal mb-4">{t("recap")}</h4>
                <div className="mb-3">
                  <span className="text-grey">{t("producteur")}: </span>
                  <span>{producteur?.name}</span>
                </div>

                {/* Products Mapping */}
                {order.products.map((product: any, index: number) => (
                  <div
                    className="text-[14px] text-grey border-solid border-b-[1px] flex justify-between"
                    key={index}
                  >
                    <span>
                      {product.quantity}/ {i18n.language === "fr" ? product.product_name : product.product_name_en}
                    </span>
                    <span>
                      {formatNombre(parseFloat(product.subtotal))}F
                    </span>
                  </div>
                ))}

                <div className="flex text-[14px] justify-between">
                  <span>{t("prix_total")} </span>
                  <span>
                    {formatNombre(parseFloat(order.total_amount))} FCFA
                  </span>
                </div>
              </div>}

              {order.supplementary_products.length > 0 && <div className="min-w-[310px] text-sm">
                <h4 className="font-normal mb-4">{t("annother_products")}</h4>


                {/* Products Mapping */}
                {order.supplementary_products.map((product: any, index: number) => (
                  <div
                    className="text-[14px] text-grey border-solid border-b-[1px] flex justify-between"
                    key={index}
                  >
                    <span>
                      {product.quantity} {product.type} {t("de")} {i18n.language === "fr" ? product.product_name : product.product_name_en}
                    </span>

                  </div>
                ))}


              </div>}
              <div>
                <div className="flex text-[15px] flex-col">
                  <div className="flex gap-2 items-center mb-4">
                    <img className="h-[13px] w-[13px]" src="/box.svg" alt="" />
                    <h4 className="font-normal text-[15px]">
                      {t("adress_livraison")}
                    </h4>
                  </div>
                  <ul className="flex flex-col gap-1 text-[13px] border-[#E8E8E8] rounded-[3px] border-[1px] px-3 py-2">
                    <li>
                      <span className="text-grey">{t("nom")}: </span>
                      <span>{order.delivery_name}</span>
                    </li>
                    <li>
                      <span className="text-grey">{t("adress")}: </span>
                      <span>{order.delivery_address}</span>
                    </li>
                    <li>
                      <span className="text-grey">
                        {order.delivery_city}, {order.delivery_country}
                      </span>
                    </li>
                    <li>
                      <span className="text-grey">{t("phone")}: </span>
                      <span>{order.delivery_phone_number}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <div className="flex text-[15px] flex-col">
                  <div className="flex gap-2 items-center mb-4 justify-between pr-1">
                    <div className="flex gap-2 items-center">
                      <img
                        className="h-[13px] w-[13px]"
                        src="/box.svg"
                        alt=""
                      />
                      <h4 className="font-normal text-[15px]">{t("producteur")}</h4>
                    </div>
                    {/* <img src="/redPhone.svg" alt="" /> */}
                  </div>
                  <ul className="flex flex-col gap-1 text-[13px] border-[#E8E8E8] rounded-[3px] border-[1px] px-3 py-2">
                    <li>
                      <span className="text-grey">{t("vendu_par")}: </span>
                      <span>{producteur?.name}</span>
                    </li>
                    <li>
                      <span className="text-grey">{t("lieu_transport")}: </span>
                      <span>
                        {order.delivery_city}, {producteur?.city}
                      </span>
                    </li>
                    <li>
                      <span className="text-grey">{t("paiement")}: </span>
                      <span>Orange Money</span>
                    </li>
                    <li>
                      <span className="text-grey">{t("phone")}: </span>
                      <span>
                        {producteur?.phone_number}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex gap-2 items-center mt-20 justify-center text-[11px]">
              {(orderDetail[0].status === "validees" || orderDetail[0].status === "en-transit") &&
                <CustomButton disabled={loader} onClick={() => commandeRecupere(order.order_id)} className="text-black bg-third px-6 py-2" rounded>
                  <span>{loader ? "......" : t("commande_recupere")}</span>
                </CustomButton>}
              {orderDetail[0].status === "validees" &&
                <CustomButton disabled={loader} onClick={() => navigate(`/recherche_trans/${Id}`, { state: order })} className="text-white bg-primary px-6 py-2" rounded>

                  {t('recherche_transporteur')}

                </CustomButton>}
              {orderDetail[0].status === "en-cours" &&
                <CustomButton onClick={() => navigate(`/paiement_achat/${order.order_id}`, { state: order })} className="text-white w-[80%] bg-primary px-6 py-2" rounded>

                  {t("payer")}

                </CustomButton>}
              {/* {orderDetail[0].status === "livrees" &&
                <CustomButton onClick={() => navigate(`/paiement_achat/${order.order_id}`, { state: order })} className="text-white bg-primary px-6 py-2" rounded>
                  {t("noter")}
                </CustomButton>} */}
            </div>
            <ToastContainer position="top-right" />
          </div>
        ))
      )}
    </div>
  );
};

export default Details;
